/****   request.js   ****/
import axios from 'axios'
import { Toast } from 'vant';

// console.info(config.baseUrl, 'config>>>>>>', process.env);
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 30 * 1000
})
service.interceptors.request.use(config => {
  config.data = JSON.stringify(config.data);
  const localParams = JSON.parse(sessionStorage.getItem('requestHeaders'))
  config.headers = {
    'Content-Type':'application/json',
    // 'zyu': '1121226551023923200',
    'rcb': process.env.VUE_APP_CHANNEL,
    'wrzLi': process.env.VUE_APP_BIZ_LINE,
    // 'vzaf': 'a4feb161-c0c0-3469-9e48-5cd25a6bf459', // appflyId
    'cksion': '1.3.2',
    'jtgleId': '',
    'G3AltNationIdentity': process.env.VUE_APP_NATION_CODE || 'co', // code：__nationCode (gt, co)
  }
  if (localParams.userGid) {
    config.headers['zyu'] = localParams.userGid
  }
  if (sessionStorage.getItem('dava_token')) {
    config.headers['gvt'] = sessionStorage.getItem('dava_token')
  }
  // if (!config.isLoginApi) {
  //   config.headers['gvt'] = sessionStorage.getItem('HEADWR_TOKEN')
  // }
  
  // const token = getCookie('名称');
  // if(token){
  //   config.params = {'token':token}
  //   config.headers.token= token;
  // }
  return config
}, error => {
  Promise.reject(error)
})

service.interceptors.response.use(response => {
  // console.log(response)
  const msg = response.data.msg ?? response.data.comnCtnomet;
  if (response.status === 200 && msg === 'success') {
    return response.data;
  }else {
    Toast(msg)
    return new Error(response.data.msg)
  }
}, error => {
  console.log(error, '>>>>>>>>>')
  // sessionStorage.setItem('dava_token', '')
  return Promise.resolve(error.response)
})
export default service
